import { Reducer } from "redux";

import { AddPortalUpdateResponse } from "../models/api/Admin";
import { GetPortalUpdateActionDispatchTypes } from "../constants/Admin";
import { GetPortalUpdateDispatchTypes } from "../models/dispatchTypes/Admin";

const initialState: AddPortalUpdateResponse = {
  loading: false,
  response: {
    userId: "",
    updateText: "",
    userCreated: "",
    dateCreated: ""
  },
  error: null,
};

const GetPortalUpdateReducer: Reducer<
  AddPortalUpdateResponse,
  GetPortalUpdateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetPortalUpdateActionDispatchTypes.GET_PORTAL_UPDATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetPortalUpdateActionDispatchTypes.GET_PORTAL_UPDATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetPortalUpdateActionDispatchTypes.GET_PORTAL_UPDATE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default GetPortalUpdateReducer;
